export default __webpack_public_path__ + "static/media/bg-overlay-section3.a2e80c43.png";